import { useEffect } from 'react';
import { Outlet, useParams, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SUPPORTED_LANGS = ['en', 'es'];

export default function LanguageWrapper() {
  const { lang } = useParams<{ lang: string }>();
  const { i18n } = useTranslation();

  // If lang param is not a valid language, don't render (let it fall through to 404/redirect)
  const isValidLang = lang && SUPPORTED_LANGS.includes(lang);

  useEffect(() => {
    if (isValidLang && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
    if (isValidLang) {
      document.documentElement.lang = lang;
    }
  }, [lang, i18n, isValidLang]);

  if (!isValidLang) {
    // If it's not a valid lang, redirect to default
    return <Navigate to={`/es${lang ? `/${lang}` : ''}`} replace />;
  }

  return <Outlet />;
}
